import React, { Component } from 'react';
import Flatpickr from 'react-flatpickr';
import styles from './styles';
import 'flatpickr/dist/themes/material_green.css'

import _ from 'lodash';

class AxlForm extends Component {

  render () {
    return (<div style={ styles.container }>
        {this.props.children}
    </div>)
  }

  static Row = class extends Component {
    render () {
        return (<div className={`clearfix`} style={ {...styles.row, ...{display: this.props.flex ? 'flex' : 'block'}} }>
            {this.props.children}
        </div>)
      }          
  }

  static Section = class extends Component {
    render () {
        return (<div style={ styles.section }>
            {this.props.children}
        </div>)
      }          
  }

  static Header = class extends Component {
    render () {
        return (<div style={ styles.header }>
            {this.props.children}
        </div>)
      }
  }

  static SubHeader = class extends Component {
    render () {
        return (<div style={ styles.subheader }>
            {this.props.children}
        </div>)
      }
  }

  static Input = class extends Component {
    render () {
      //inject attributes
      const props = _.omit(this.props, ['fluid', 'flex']);
      const inputStyle = this.props.error ? {
        ...styles.input,
        ...styles.error
      } : {
        ...styles.input
      }
      const formField = {
        ...styles.formField,
        ...{ display: this.props.flex ? 'flex' : 'block' },
        ...{ width: this.props.fluid ? '100%' : 'auto' },
        ...{ flex: this.props.flex ? '1' : '0' }
      }

      return (<div style={formField}>
        <input {...props} value={this.props.value} placeholder={this.props.placeholder} style={inputStyle}/>
        <span style={styles.textError}>{this.props.error}</span>
      </div>)
    }

  }

  static TextArea = class extends Component {
    render () {
      const props = _.omit(this.props, ['fluid', 'flex', 'error']);
      const style = this.props.error ? {...styles.textarea, ...styles.error,...{ width: this.props.fluid ? '100%' : 'auto' }} : {...styles.textarea,...{ width: this.props.fluid ? '100%' : 'auto' }}
        return (<div style={styles.formField}>
          <textarea placeholder={this.props.placeholder} style={style} {...props} />
          <span style={styles.textError}>{this.props.error}</span>
        </div>)
      }
  }

  static CheckBox = class extends Component {
    render () {
      const props = _.omit(this.props, ['fluid', 'children']);
      return (<div style={ {...styles.checkboxContainer }}>
        <label style={ {...styles.checkboxLabel }}>
          <input {...props} type="checkbox" style={ {...styles.checkbox }} />{this.props.children}</label>
        <span style={styles.textError}>{this.props.error}</span>
      </div>)
    }
  }

  static DateInput = class extends Component {
    render () {
      //inject attributes
      const props = _.omit(this.props, ['name', 'error', 'fluid']);

      return <div style={styles.formField} className={this.props.error && 'error'}>
        <Flatpickr
          data-enable-time
          {...props}/>
        <span style={styles.textError}>{this.props.error}</span>
      </div>
    }
  }
}

export default AxlForm